module.exports = __webpack_public_path__ + "img/Varmvandsbeholder-App-front.d5b237ab.png";